<template>
<div class="chapter">
<div class="inner_page">
<h1>Runaway Passion</h1>
<h3><i>Silver Creek Stories: Book Three</i></h3>
<h3 class="sigil_not_in_toc">Vivian Vaughan</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01b_title.vue?dfa42aea